import React from 'react';

export class Button extends React.Component {
  constructor (props) {
    super(props);
    this.state = {};
  }

  onClick = () => {
    this.props.onClick && this.props.onClick();
  }

  render () {
    return (
      <div className="button" onClick={this.onClick}>{ this.props.children }</div>
    );
  }
}
